import {axiosInstanceWithToken} from '../utils/Client';

export default class JobDescriptionService {
    static getJobTitleData = (locationId) => {
        return axiosInstanceWithToken.get(`/agency_job_titles/${locationId}/`);
    };

    static getJobDescriptionData = (selectedJobId) => {
        return axiosInstanceWithToken.get(`/job_description/${selectedJobId}/`);
    };

    static saveNewDescription = (selectedJobId, jobDescription) => {
        return axiosInstanceWithToken.post(
            `/job_description/${selectedJobId}/`,
            jobDescription
        );
    };

    static upadteDescription = (jobDescription) => {
        return axiosInstanceWithToken.put(
            `/job_description/edit/${jobDescription.id}/`,
            jobDescription
        );
    };

    static deleteDescription = (jobDescriptionId) => {
        return axiosInstanceWithToken.delete(`/job_description/edit/${jobDescriptionId}/`);
    };

    static reorderDescriptions = (jobDescriptions, jobId) => {
        return axiosInstanceWithToken.put(
            `/job_description/reorder/${jobId}/`,
            jobDescriptions
        );
    };

    static getDescriptionPDFContent = (jobTitleId) => {
        return axiosInstanceWithToken.get(`/job_description/report/${jobTitleId}/`);
    };

    static getJobTitleReviewStatus = (jobTitleId) => {
        return axiosInstanceWithToken.get(`/iw/review/status/${jobTitleId}/`);
    };

    static saveJobTitleReviewStatus = (jobTitleId, data) => {
        return axiosInstanceWithToken.put(`/iw/review/status/${jobTitleId}/`, data);
    };

    static copyDescriptions = (newDescriptionList, copyFrom, copyTo) => {
        return axiosInstanceWithToken.post(
            `/job_description/copy/${copyFrom}/${copyTo}/`, 
            newDescriptionList
        );
    };
}



// WEBPACK FOOTER //
// ./src/services/JobDescriptionService.js